export interface LeaderboardEntry {
  rank: number;
  username: string;
  displayName: string;
  contributions: number;
  /** The person's most used languages, codes, most used first. */
  languages: string[];
  userId?: string;
}

export interface LeaderboardData {
  entries: LeaderboardEntry[];
  /** null when the API gives no total: the caller counts the entries. */
  total: number | null;
}

export type ViewMode = 'global' | 'language';

/**
 * The backend ranks on one count only: recorded audios, written
 * transcriptions and answers to questions. The `metric` query parameter is
 * ignored, so there is no earnings board to switch to.
 */
export type Metric = 'contributions';

export type LeaderboardPeriod = 'week' | 'month' | 'all';

/** Value of the language Select that means "every language" (the global board). */
export const ALL_LANGUAGES = 'all';
